let suggestionBoxText = [];

export const getSBTextStatus = async (fn, id) => {
  let result = await fn(id);

  let array = [];

  for (let i = 0; i < result?.payLoad?.length; i++) {
    const elementI = result?.payLoad[i];
    let obj = {
      id: 0,
      status: "",
      tabName: "",
      text: [],
      translationKey: "",
    };
    obj.id = elementI.aboutStatusViewId;
    obj.status = elementI.isVisited;
    obj.tabName = elementI.sectionName;
    obj.translationKey = elementI.translationKey;

    let htmlArray = [];

    for (let j = 0; j < elementI.aboutStatusHtmlText.length; j++) {
      const elementJ = elementI.aboutStatusHtmlText[j];
      let htmlObj = {
        __html: "",
      };
      htmlObj.__html = elementJ;
      htmlArray.push(htmlObj);
    }
    obj.text = htmlArray;
    array.push(obj);
  }
  suggestionBoxText = array;
  return suggestionBoxText;
};

export const updateSBTextStatus = async (id) => {
  let array = suggestionBoxText;
  for (let i = 0; i < array.length; i++) {
    const elementI = array[i];
    if (elementI.id === id) {
      elementI.status = !elementI.status;
    }
  }
  suggestionBoxText = array;
};
